import { isReconciledReport, OpenerSalesReport } from '../components/GeneralSales/components/SessionBriefModal/components/OpenerSalesSection';

/** Exact minor-unit columns preserve the same reconciliation as the UI. */
export function attributionExportRows(report: OpenerSalesReport, sessionId: number, shiftId?: number) {
  if (!isReconciledReport(report)) throw new Error('Invalid attribution report');
  return (['waiters', 'salons'] as const).flatMap(dimension =>
    Object.values(report[dimension]).map(row => ({
      'ID Sesión': sessionId,
      'ID Turno': shiftId ?? '',
      'Dimensión': dimension === 'waiters' ? 'Mesero de apertura' : 'Salón de apertura',
      'ID': row.id ?? '',
      'Nombre': row.name,
      'Neto (centavos)': row.net_minor,
      'Recibos asociados': row.receipt_count,
      'Total atribuido (centavos)': report.attributed_net_minor,
      'Total anterior (centavos)': report.legacy_net_minor,
      'Total del periodo (centavos)': report.scope_net_minor,
    })));
}
